export default __webpack_public_path__ + "static/media/sort_desc.46162f05.svg";